import React, { useState, useEffect, useContext } from 'react';
import {
  Box,
  Typography,
  Paper,
  FormControlLabel,
  Checkbox,
  IconButton,
  Radio,
  RadioGroup,
  Avatar,
  Button,
  Grid,
  Divider,
  Card,
  Table,
  TableBody,
  Container,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  AppBar,
  Toolbar,
  CircularProgress,
  Alert,
  Tabs,
  Tab
} from '@mui/material';
import { AuthContext } from "./../../../AuthContext/AuthContext";
import { BASE_URL } from "./../../../Api/ApiUrls";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import FormsBottomNavbar from "./../../Post Module/FormsBottomNavbar";
import ActiveSubscription from './ActiveSubscription';
import SubscriptionForm from './SubscriptionForm';

const UserSubscriptionPanel = () => {
  const [selectedUserType, setSelectedUserType] = useState('');
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedAddon, setSelectedAddon] = useState(null);
  const [plans, setPlans] = useState([]);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    // Fetch active subscription for the user
const [subscriptions, setSubscriptions] = useState([]); // Rename from activeSubscription to subscriptions
  const [tabValue, setTabValue] = useState(1); // Default to Subscription Plans tab
  const { userId } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      if (!userId) return;

      try {
        setLoading(true);
        const response = await fetch(`${BASE_URL}/users/${userId}/`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setUserData(data);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching user data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [userId]);


useEffect(() => {
  const fetchActiveSubscription = async () => {
    if (!userId) return;

    try {
      setLoading(true);
      const response = await fetch(`https://landnest.net:81/Get-all-plan/${userId}/`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      // Handle case where response might be wrapped in a data property
      const data = Array.isArray(result) ? result : result.data || [];
      
      console.log("All subscriptions for user:", data);
      setSubscriptions(data); // Store all subscriptions
      
      // Find active subscription
      const activeSub = data.find(sub => sub.status === true);
      
      if (activeSub) {
        // If there's an active subscription, switch to that tab
        // setTabValue(0);
        setTabValue(1); // Switch to Subscription Plans tab
      }
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching subscription data:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchActiveSubscription();
}, [userId]);

  // Fetch plans from API
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://landnest.net:81/subplans/');
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        setPlans(result);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching subscription plans:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

 const handlePaymentSubmit = async (e) => {
  e.preventDefault();
  setError(null); // Clear previous errors

  // Ensure either a plan or addon is selected
  if (!selectedPlan && !selectedAddon) {
    alert("Please select a plan or addon before submitting.");
    return;
  }

  try {
    let payload, apiUrl;

    if (selectedPlan) {
      // Prepare payload for main plan submission
      payload = {
        user_id: userId,
        plan_name: selectedPlan.plan_name,
        user_type: selectedPlan.user_type,
        charges: Number(selectedPlan.charges),
        reward_amount: selectedPlan.reward_amount ? Number(selectedPlan.reward_amount) : 0,
        pay_amount: selectedPlan.reward_amount 
          ? Number(selectedPlan.charges) + Number(selectedPlan.reward_amount)
          : Number(selectedPlan.charges),
        buyer_no_unlimited: selectedPlan.buyer_no_unlimited || false,
        buyer_no: selectedPlan.buyer_no_unlimited ? null : Number(selectedPlan.buyer_no),
        no_of_properties_unlimited: selectedPlan.no_of_properties_unlimited || false,
        no_of_liked_data_unlimited: selectedPlan.no_of_liked_data_unlimited || false,
        matching_enquiry_unlimited: selectedPlan.matching_enquiry_unlimited || false,
        no_of_properties: selectedPlan.no_of_properties_unlimited ? null : Number(selectedPlan.no_of_properties),
        no_of_liked_data: selectedPlan.no_of_liked_data_unlimited ? null : Number(selectedPlan.no_of_liked_data),
        matching_enquiry: selectedPlan.matching_enquiry_unlimited ? null : Number(selectedPlan.matching_enquiry),
        status: true,
        sub_type: 'New'
      };
      apiUrl = 'https://landnest.net:81/subusers/';
    } else if (selectedAddon) {
      // Prepare payload for addon submission
      payload = {
        user_id: userId,
        user_type: selectedAddon.user_type,
        charges: Number(selectedAddon.charges),
        reward_amount: selectedAddon.reward_amount ? Number(selectedAddon.reward_amount) : 0,
        pay_amount: selectedAddon.reward_amount 
          ? Number(selectedAddon.charges) + Number(selectedAddon.reward_amount)
          : Number(selectedAddon.charges),
        buyer_no_unlimited: selectedAddon.buyer_no_unlimited || false,
        buyer_no: selectedAddon.buyer_no_unlimited ? null : Number(selectedAddon.buyer_no),
        no_of_properties_unlimited: selectedAddon.no_of_properties_unlimited || false,
        no_of_liked_data_unlimited: selectedAddon.no_of_liked_data_unlimited || false,
        matching_enquiry_unlimited: selectedAddon.matching_enquiry_unlimited || false,
        no_of_properties: selectedAddon.no_of_properties_unlimited ? null : Number(selectedAddon.no_of_properties),
        no_of_liked_data: selectedAddon.no_of_liked_data_unlimited ? null : Number(selectedAddon.no_of_liked_data),
        matching_enquiry: selectedAddon.matching_enquiry_unlimited ? null : Number(selectedAddon.matching_enquiry),
        status: true
      };
      apiUrl = 'https://landnest.net:81/user-addon/';
    }

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Payment failed');
    }

    const result = await response.json();
    console.log(selectedPlan ? 'Plan' : 'Addon', 'created successfully:', result);
    
    // Handle the response properly
    if (selectedPlan) {
      // If the API returns the new subscription, add it to existing ones
      setSubscriptions(prevSubs => [...prevSubs, result]);
    }
    
    setTabValue(0); // Switch to Active Subscription tab
    alert(`${selectedPlan ? 'Plan' : 'Addon'} created successfully!`);
    navigate('/work-detail');

  } catch (err) {
    console.error("Payment error:", err);
    setError(err.message);
    alert(`Payment failed: ${err.message}`);
  }
};


// const handlePaymentSubmit = async (e) => {
//   e.preventDefault();
//   setError(null); 
//   setLoading(true); 

//   if (!selectedPlan && !selectedAddon) {
//     alert("Please select a plan or addon before submitting.");
//     setLoading(false); 
//     return;
//   }

//   try {
//     let payload, apiUrl;
// const pay_amounts = Number(selectedPlan.charges) + Number(selectedPlan.reward_amount);
//     if (selectedPlan) {
    
//       payload = {
//         user_id: userId,
//         plan_name: selectedPlan.plan_name,
//         user_type: selectedPlan.user_type,
//         charges: Number(selectedPlan.charges),
//         reward_amount: selectedPlan.reward_amount ? Number(selectedPlan.reward_amount) : 0,
//         pay_amount: selectedPlan.reward_amount 
//           ? Number(selectedPlan.charges) + Number(selectedPlan.reward_amount)
//           : Number(selectedPlan.charges),
//         buyer_no_unlimited: selectedPlan.buyer_no_unlimited || false,
//         buyer_no: selectedPlan.buyer_no_unlimited ? null : Number(selectedPlan.buyer_no),
//         no_of_properties_unlimited: selectedPlan.no_of_properties_unlimited || false,
//         no_of_liked_data_unlimited: selectedPlan.no_of_liked_data_unlimited || false,
//         matching_enquiry_unlimited: selectedPlan.matching_enquiry_unlimited || false,
//         no_of_properties: selectedPlan.no_of_properties_unlimited ? null : Number(selectedPlan.no_of_properties),
//         no_of_liked_data: selectedPlan.no_of_liked_data_unlimited ? null : Number(selectedPlan.no_of_liked_data),
//         matching_enquiry: selectedPlan.matching_enquiry_unlimited ? null : Number(selectedPlan.matching_enquiry),
//         status: true,
//         sub_type: 'New'
//       };
//       apiUrl = 'https://landnest.net:81/subusers/';
//     } else if (selectedAddon) {
//       payload = {
//         user_id: userId,
//         user_type: selectedAddon.user_type,
//         charges: Number(selectedAddon.charges),
//         reward_amount: selectedAddon.reward_amount ? Number(selectedAddon.reward_amount) : 0,
//         pay_amount: selectedAddon.reward_amount 
//           ? Number(selectedAddon.charges) + Number(selectedAddon.reward_amount)
//           : Number(selectedAddon.charges),
//         buyer_no_unlimited: selectedAddon.buyer_no_unlimited || false,
//         buyer_no: selectedAddon.buyer_no_unlimited ? null : Number(selectedAddon.buyer_no),
//         no_of_properties_unlimited: selectedAddon.no_of_properties_unlimited || false,
//         no_of_liked_data_unlimited: selectedAddon.no_of_liked_data_unlimited || false,
//         matching_enquiry_unlimited: selectedAddon.matching_enquiry_unlimited || false,
//         no_of_properties: selectedAddon.no_of_properties_unlimited ? null : Number(selectedAddon.no_of_properties),
//         no_of_liked_data: selectedAddon.no_of_liked_data_unlimited ? null : Number(selectedAddon.no_of_liked_data),
//         matching_enquiry: selectedAddon.matching_enquiry_unlimited ? null : Number(selectedAddon.matching_enquiry),
//         status: true
//       };
//       apiUrl = 'https://landnest.net:81/user-addon/';
//     }

//     const response = await fetch(apiUrl, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(payload)
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.message || 'Payment failed');
//     }

//     const result = await response.json();
//     console.log(selectedPlan ? 'Plan' : 'Addon', 'created successfully:', result);
    
//     if (selectedPlan) {
//       setSubscriptions(prevSubs => [...prevSubs, result]);
//     }

//     setTabValue(0); 
//     alert(`${selectedPlan ? 'Plan' : 'Addon'} created successfully!`);

//     const paymentResponse = await fetch("https://landnest.net:81/create-payment/", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ amount: pay_amounts }), 
//     });

//     const orderData = await paymentResponse.json();
//     if (!orderData.status) {
//       alert("Failed to create order");
//       setLoading(false);
//       return;
//     }

//     const options = {
//       key: orderData.key, 
//       amount: orderData.amount, 
//       currency: orderData.currency,
//       name: "My Shop",
//       description: "Test Transaction",
//       order_id: orderData.order_id,
//       handler: async function (paymentResponse) {
//         const verifyRes = await fetch("https://landnest.net:81/verify-payment/", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(paymentResponse),
//         });

//         const verifyData = await verifyRes.json();
//         if (verifyData.status) {
//           alert("✅ Payment successful!");
//         } else {
//           alert("❌ Payment verification failed!");
//         }
//       },
//       theme: {
//         color: "#3399cc",
//       },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//     setLoading(false); 
//     navigate('/work-detail'); 

//   } catch (err) {
//     console.error("Error:", err);
//     setError(err.message);
//     alert(`Error: ${err.message}`);
//     setLoading(false); 
//   }
// };


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: 'rgb(239, 231, 221)',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
        <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
          Loading User Subscription...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Container sx={{ mt: 2 }}>
        <Alert severity="error">
          Error: {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Box sx={{
      display: 'flex', 
      flexDirection: 'column',
      minHeight: '100vh',
      background: `
        linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
        url('/construction4.png')
      `,
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
      // pt: '64px',
      mt: '70px'
    }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          background: `
            linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)),
            url('/construction5.png')
          `,
          color: 'text.primary',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          <IconButton
            edge="start"
            onClick={() => navigate(-1)}
            sx={{
              color: '#ffffff',
              backgroundColor: 'rgba(255,255,255,0.1)',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.2)'
              }
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '4px 8px',
            borderRadius: '16px',
            backgroundColor: 'rgba(255,255,255,0.1)',
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.2)'
            }
          }}>
            <Avatar
              alt={userData?.username || "User"}
              src={userData?.profile ? `${BASE_URL}${userData.profile}` : ""}
              sx={{
                width: 36,
                height: 36,
                mr: 1.5,
                border: '2px solid rgba(255,255,255,0.3)'
              }}
            />
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#ffffff' }}>
                {userData?.username || "Loading..."}
              </Typography>
              <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.7rem' }}>
                {userData?.user_id ? `CUSTOMER${userData.user_id.toString().padStart(4, '0')}` : "Loading..."}
              </Typography>
            </Box>
          </Box>
        </Toolbar> 
      </AppBar>

<Tabs 
  value={tabValue} 
  onChange={handleTabChange} 
  variant="fullWidth"
  sx={{
    borderRadius: '30px',
    
    overflow: 'hidden',
    boxShadow: '0 5px 10px rgba(0,0,0,0.1)',
    backgroundColor: 'transparent',
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .Mui-selected': {
      color: '#333333 !important' // Force black text for active tab
    }
  }}
>
  <Tab 
    label="Active Subscription" 
    sx={{ 
      zIndex: 1,
      py: 2,
      background: tabValue === 0 ? `
        linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
        url('/construction4.png')
      ` : `
        linear-gradient(145deg, rgb(22, 22, 22), rgb(15, 15, 15)),
        url('/construction5.png')
      `,
      backgroundBlendMode: 'overlay',
      color: tabValue === 0 ? '#333333 !important' : 'rgba(255,255,255,0.9) !important',
      fontWeight: 700,
      fontSize: '0.8rem',
      textTransform: 'none',
      fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
      borderRight: '1px solid rgba(0,0,0,0.1)',
      borderTopLeftRadius: '30px',
      borderBottomLeftRadius: '30px',
      transition: 'all 0.3s ease',
      position: 'relative',
      '&:hover': {
        transform: tabValue === 0 ? 'scale(1.02)' : 'scale(1.02)',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: tabValue === 0 ? '70%' : '0%',
        height: '3px',
        backgroundColor: tabValue === 0 ? '#333333' : 'rgba(255,255,255,0.9)',
        borderRadius: '3px',
        transition: 'all 0.3s ease',
      },
      '&.Mui-selected': {
        color: '#333333 !important' // Explicitly set for active state
      }
    }} 
  />
  <Tab 
    label="Subscription Plans" 
    sx={{ 
      zIndex: 1,
      py: 2,
      background: tabValue === 1 ? `
        linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
        url('/construction4.png')
      ` : `
        linear-gradient(145deg, rgb(22, 22, 22), rgb(15, 15, 15)),
        url('/construction5.png')
      `,
      backgroundBlendMode: 'overlay',
      color: tabValue === 1 ? '#333333 !important' : 'rgba(255,255,255,0.9) !important',
      fontWeight: 700,
      fontSize: '0.8rem',
      textTransform: 'none',
      fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
      borderTopRightRadius: '30px',
      borderBottomRightRadius: '30px',
      transition: 'all 0.3s ease',
      position: 'relative',
      '&:hover': {
        transform: tabValue === 1 ? 'scale(1.02)' : 'scale(1.02)',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: tabValue === 1 ? '70%' : '0%',
        height: '3px',
        backgroundColor: tabValue === 1 ? '#333333' : 'rgba(255,255,255,0.9)',
        borderRadius: '3px',
        transition: 'all 0.3s ease',
      },
      '&.Mui-selected': {
        color: '#333333 !important' // Explicitly set for active state
      }
    }} 
  />
</Tabs>
      {/* Tab Content */}
      {/* <Box sx={{ p: 2 }}> */}
        {tabValue === 0 && subscriptions ? (
          <ActiveSubscription 
            subscriptions={subscriptions}  
            userData={userData} 
            navigate={navigate} 
          />
        ) : (
          <SubscriptionForm
            selectedUserType={selectedUserType}
            setSelectedUserType={setSelectedUserType}
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
             selectedAddon={selectedAddon}
      setSelectedAddon={setSelectedAddon}
            plans={plans}
            handlePaymentSubmit={handlePaymentSubmit}
              subscriptions={subscriptions}  // Add this line 7-jul-2025
          />
        )}
      {/* </Box> */}

      <Box sx={{ height: '64px' }} />
      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
        <FormsBottomNavbar />
      </Box>
    </Box>
  );
};

export default UserSubscriptionPanel;